import {
  Users,
  LayoutDashboard,
  Landmark,
  Code2,
  DollarSign,
  Monitor,
  AtSign,
  Settings,
  PieChart,
  BotMessageSquare,
  ReceiptText
} from "lucide-react"
import { UserRole, NavItemType } from "../../types"

export type RoutePath =
  | "dashboard"
  | "stats"
  | "brands"
  | "integrations"
  | "loan-officers"
  | "pricing-log"
  | "lo-dashboard"
  | "rates"
  | "dream-rate"
  | "engagements"
  | "organizations"
  | "config-admin"
  | "conversations"
  | "billing"
  | "account/billing"
  | "account/payment-management"
  | "loan-programs"
  | "pricing-engine"
  | "channel-leads"

export type SubRoutePath = "subscriptions" | "dream-rate" | "leads" | "activity"

export const ALLOWED_ROLES_BY_ROUTE: { [key in RoutePath]: UserRole[] } = {
  dashboard: ["bank admin", "administrator"],
  brands: ["bank admin", "administrator"],
  integrations: ["bank admin", "administrator"],
  "loan-officers": ["bank admin", "administrator"],
  "pricing-log": ["bank admin", "administrator"],
  "lo-dashboard": ["loan officer"],
  rates: ["loan officer", "bank admin", "administrator"],
  "dream-rate": ["loan officer", "bank admin", "administrator"],
  engagements: ["loan officer", "bank admin", "administrator"],
  organizations: ["bank admin", "administrator"],
  billing: ["administrator"],
  "account/billing": ["bank admin", "administrator"],
  "account/payment-management": ["bank admin", "administrator"],
  stats: ["bank admin", "administrator"],
  "config-admin": ["administrator"],
  conversations: ["loan officer", "bank admin", "administrator"],
  "loan-programs": ["bank admin", "administrator"],
  "pricing-engine": ["bank admin", "administrator"],
  "channel-leads": ["bank admin", "administrator"]
}

const Items: NavItemType[] = [
  {
    key: "dashboard",
    name: "Organizations",
    href: "/",
    icon: LayoutDashboard
  },
  { key: "brands", name: "Brands", href: "/brands", icon: Landmark },
  {
    key: "loan-officers",
    name: "Loan officers",
    href: "/loan-officers",
    icon: Users
  },
  {
    key: "integrations",
    name: "Integrations",
    href: "/integrations",
    icon: Code2
  },
  {
    key: "loan-programs",
    name: "Loan programs",
    href: "/loan-programs",
    icon: DollarSign
  },
  {
    key: "rates",
    name: "Rates",
    href: "/rates",
    icon: DollarSign
  },
  {
    key: "pricing-log",
    name: "Pricing log",
    href: "/pricing-log",
    icon: Monitor
  },
  {
    key: "engagements",
    name: "Engagements",
    href: "/engagements",
    icon: AtSign,
    children: [
      {
        key: "subscriptions",
        name: "Subscriptions",
        href: "/engagements?tab=engagements"
      },
      { key: "leads", name: "Website leads", href: "/engagements?tab=leads" },
      {
        key: "dream-rate",
        name: "Dream rate",
        href: "/engagements?tab=dreamRate"
      },
      { key: "activity", name: "Activity", href: "/engagements?tab=activity" }
    ]
  },
  {
    key: "config-admin",
    name: "Config admin",
    href: "/config-admin",
    icon: Settings
  },
  {
    key: "conversations",
    name: "Conversations",
    href: "/conversations",
    icon: BotMessageSquare
  },
  {
    key: "stats",
    name: "Stats",
    href: "/stats",
    icon: PieChart
  },
  {
    key: "billing",
    name: "Billing",
    href: "/billing",
    icon: ReceiptText
  }
]

export const NavbarItems: { [key in UserRole]: NavItemType[] } = {
  administrator: Items,
  "bank admin": Items.filter(item =>
    ALLOWED_ROLES_BY_ROUTE[item.key]?.includes("bank admin")
  ),
  "loan officer": Items.filter(item =>
    ALLOWED_ROLES_BY_ROUTE[item.key]?.includes("loan officer")
  ),
  "authenticated user": Items.filter(item =>
    ALLOWED_ROLES_BY_ROUTE[item.key]?.includes("authenticated user")
  ),
  realtor: Items.filter(item =>
    ALLOWED_ROLES_BY_ROUTE[item.key]?.includes("realtor")
  )
}

export const addNewDropdownItems = [
  { name: "Brand", href: "#", icon: Landmark, adminOnly: true },
  { name: "Loan officer", href: "#", icon: Users, adminOnly: true },
  { name: "Integration", href: "#", icon: Code2, adminOnly: true },
  { name: "Loan program", href: "#", icon: DollarSign, adminOnly: true },
  { name: "Lead", href: "#", icon: AtSign, adminOnly: false }
]
